import { motion } from "framer-motion";
import WhaleLogo from "./WhaleLogo";
import { INTRO_MS } from "../lib/constants";

const SplashBubble = ({ style }) => (
  <span
    className="absolute rounded-full border-[3px] border-ocean-navy/20 bg-white/60"
    style={style}
  />
);

export default function Intro() {
  return (
    <motion.div
      data-testid="intro-splash"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gradient-to-b from-[#BAE6FD] to-[#7DD3FC] overflow-hidden"
      initial={{ y: 0 }}
      exit={{ y: "-100%", borderBottom: "14px solid #0F172A" }}
      transition={{ duration: 0.7, ease: [0.83, 0, 0.17, 1], delay: INTRO_MS / 1000 }}
    >
      {[
        { w: 26, h: 26, left: "12%", bottom: "8%", delay: "0s" },
        { w: 40, h: 40, left: "78%", bottom: "16%", delay: "0.4s" },
        { w: 18, h: 18, left: "60%", bottom: "6%", delay: "0.8s" },
        { w: 32, h: 32, left: "30%", bottom: "20%", delay: "1.1s" },
      ].map((b, i) => (
        <SplashBubble
          key={i}
          style={{ width: b.w, height: b.h, left: b.left, bottom: b.bottom, animation: `bubble-rise 2.4s ${b.delay} ease-out infinite` }}
        />
      ))}
      <motion.div
        initial={{ scale: 0.6, rotate: -8, opacity: 0 }}
        animate={{ scale: 1, rotate: 0, opacity: 1 }}
        transition={{ duration: 0.55, ease: "backOut" }}
      >
        <WhaleLogo className="w-28 h-28 drop-shadow-[4px_4px_0_#0F172A]" />
      </motion.div>
      <motion.p
        className="mt-6 font-display text-3xl font-semibold tracking-wide text-ocean-navy"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.25, duration: 0.4 }}
      >
        $BLUE
      </motion.p>
      <motion.p
        className="mt-1 text-xs font-bold uppercase tracking-[0.3em] text-ocean-navy/60"
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.4 }}
      >
        Big heart. Bigger waves.
      </motion.p>
    </motion.div>
  );
}
